import { BiCustomize } from 'react-icons/bi';
import { FaCompressAlt, FaExpandAlt } from 'react-icons/fa';
import { GiButterfly, GiBullHorns, GiCondorEmblem } from 'react-icons/gi';
import { RiBearSmileLine } from 'react-icons/ri';

const strategyList = [
  {
    id: 1,
    name: 'Custom',
    icon: <BiCustomize />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 2,
    name: 'Short Strangle',
    icon: <FaCompressAlt />,
    rowValues: [
      {
        buyOrSell: 'SELL',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 3,
    name: 'Short Straddle',
    icon: <FaCompressAlt />,
    rowValues: [
      {
        buyOrSell: 'SELL',
        atm: 0,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 4,
    name: 'Long Strangle',
    icon: <FaExpandAlt />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'BUY',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 5,
    name: 'Long Straddle',
    icon: <FaExpandAlt />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 6,
    name: 'Iron Butterfly',
    icon: <GiButterfly />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 7,
    name: 'Iron Condor',
    icon: <GiCondorEmblem />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: -2,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'BUY',
        atm: 2,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 8,
    name: 'Bear Call Spread',
    icon: <RiBearSmileLine />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: -1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 9,
    name: 'Bear Put Spread',
    icon: <RiBearSmileLine />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 10,
    name: 'Bull Call Spread',
    icon: <GiBullHorns />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: 0,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 1,
        type: 'CALL',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
  {
    id: 11,
    name: 'Bull Put Spread',
    icon: <GiBullHorns />,
    rowValues: [
      {
        buyOrSell: 'BUY',
        atm: -1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
      {
        buyOrSell: 'SELL',
        atm: 1,
        type: 'PUT',
        tpType: 'percentage',
        tpVal: 0,
        slVal: 0,
        expiry: 'MONTHLY',
      },
    ],
  },
];
strategyList.map(strategy =>
  strategy['rowValues'].map(row => (row.positionType = 'option'))
);

export default {
  strategyList: strategyList,
};
